import { render, staticRenderFns } from "./FolderPlusOutline.vue?vue&type=template&id=4d6301bc"
import script from "./FolderPlusOutline.vue?vue&type=script&lang=js"
export * from "./FolderPlusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports